import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import TopNav from "./TopNav";

// Where each role lands after login (and when opening the site's root URL).
export const homePathFor = (role) => (role === "ADMIN" ? "/admin" : "/dashboard");

// Full-page "checking your session" state, shown while GET /user/me is in flight.
function SessionCheck() {
  return <div className="page-container">Loading...</div>;
}

// Used for "/" and unknown URLs: send a signed-in user to their home page,
// everyone else to the login page. Waits for the session check first, so a
// user with a valid cookie is never flashed the login screen.
export function HomeRedirect() {
  const { user, initialized } = useSelector((state) => state.auth);
  if (!initialized) return <SessionCheck />;
  return <Navigate to={user ? homePathFor(user.role) : "/login"} replace />;
}

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, initialized } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!initialized) return <SessionCheck />;

  // Not signed in (or the 7-day cookie expired): go to login, but remember
  // where they were heading so login can bring them straight back.
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={homePathFor(user.role)} replace />;
  }

  return (
    <>
      <TopNav />
      {children}
    </>
  );
}